export default "/_next/static/images/effect-left-3-8b2f293efb2379fdcfc1376ea96168a1.svg";